import { motion } from 'framer-motion';

export function Hero() {
  const signalBars = [
    { label: 'ACOUSTIC · COUGH BIOMARKER', width: '82%', delay: 0.1 },
    { label: 'RADIOLOGY · CXR CONSOLIDATION', width: '76%', delay: 0.3 },
    { label: 'CLINICAL · SYMPTOM ALIGNMENT', width: '91%', delay: 0.5 },
    { label: 'CTF FUSION · CONCEPT ALIGNMENT', width: '88%', delay: 0.7 },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-tealLight/30 to-paper py-20 lg:py-32">
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* DISCLAIMER — Top Left Corner */}
      {/* ════════════════════════════════════════════════════════════════ */}
      <div className="absolute top-4 left-4 z-10 max-w-xs">
        <div className="p-3 bg-amber-50/95 border-l-4 border-amber-500 rounded-r-lg shadow-lg">
          <div className="flex items-start gap-2">
            <span className="text-lg flex-shrink-0 mt-0.5">⚠️</span>
            <div className="text-xs text-amber-800/90 leading-relaxed">
              <p className="font-semibold text-amber-900 text-[10px] uppercase tracking-wider">Disclaimer</p>
              <ul className="mt-1 space-y-0.5 list-disc list-inside text-[10px] text-amber-800/80">
                <li>Website under active development</li>
                <li>Metrics may be simulated/test data</li>
                <li>Not a validated clinical claim</li>
                <li>Not for diagnosis or treatment</li>
                <li>Not a commercial medical product</li>
                <li>Regulatory review not complete</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-tealLight border border-teal/20 text-teal text-xs font-semibold mb-6 uppercase tracking-wider">
            Clinical AI · SaMD · Precision Medicine
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-ink leading-tight">
            The <span className="text-teal">intelligence layer</span> between a clinician and a diagnosis
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-inkSoft max-w-3xl mx-auto leading-relaxed">
            Diagnostic Intelligence is an AI Platform for Life Sciences, Healthcare & MedTech. We develop AI-native multimodal clinical intelligence solutions powered by our proprietary Concept Tuning & Fusion (CTF) architecture. Our platform integrates acoustic biomarkers, medical imaging, pathology, laboratory, clinical, and multi-omics data to deliver explainable AI for precision diagnostics, risk stratification, biomarker discovery, clinical decision support, and translational research.
          </p>
          <div className="mt-10 flex justify-center gap-4 flex-wrap">
            <a
              href="/platform"
              className="px-6 py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all"
            >
              Explore Platform
            </a>
            <a
              href="/company/contact"
              className="px-6 py-3 bg-white text-ink font-medium rounded-lg border border-rule hover:bg-paper2 transition-all"
            >
              Contact Us
            </a>
          </div>
        </motion.div>
      </div>

      <div className="max-w-4xl mx-auto mt-16 px-4">
        <div className="bg-ink rounded-lg p-6 border border-rule/20">
          <div className="font-mono text-xs text-tealMid mb-4">// CTF ENGINE · LIVE INFERENCE</div>
          {signalBars.map((item, i) => (
            <div key={i} className="mb-4">
              <div className="font-mono text-xs text-gray-400 mb-1">{item.label}</div>
              <div className="bg-gray-800 rounded-full h-2 overflow-hidden">
                <motion.div
                  className="bg-gradient-to-r from-tealMid to-teal h-full rounded-full"
                  initial={{ width: 0 }}
                  animate={{ width: item.width }}
                  transition={{ duration: 1, delay: item.delay }}
                />
              </div>
            </div>
          ))}
          <div className="font-mono text-2xl text-white mt-4">
            0.88 <span className="text-sm text-tealMid">TB Risk Score</span>
          </div>
          <div className="text-xs text-gray-400 mt-1">
            Primary contributors: wet crackles · right upper lobe opacity · fever duration
          </div>
          <div className="inline-block mt-3 bg-teal/20 text-tealMid font-mono text-xs px-3 py-1 rounded">
            ⬡ SNOMED-aligned · Explainable · Audit-ready
          </div>
        </div>
      </div>
    </section>
  );
}
